import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/base/JsonLd";
import { blogArticles } from "@/mocks/blog-articles";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://kakobuypolska.com";

const categories = ["Wszystkie", "Przewodnik", "Tutorial", "Produkty", "Poradnik", "Bezpieczeństwo", "Wysyłka", "Ranking", "Porównanie", "Opinie", "Styl", "Społeczność", "Analiza"];

const blogJsonLd = {
  "@context": "https://schema.org",
  "@type": "Blog",
  name: "Blog Kakobuy Spreadsheet Polska",
  description: "Artykuły, poradniki i przewodniki o zakupach na Kakobuy. Wszystko czego potrzebujesz aby kupować mądrzej i bezpieczniej.",
  url: `${siteUrl}/blog`,
  publisher: {
    "@type": "Organization",
    name: "Kakobuy Spreadsheet Polska",
    logo: {
      "@type": "ImageObject",
      url: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png",
    },
  },
  blogPost: blogArticles.map((a) => ({
    "@type": "BlogPosting",
    headline: a.title,
    description: a.excerpt,
    image: a.image,
    datePublished: a.date,
    url: `${siteUrl}/blog/${a.slug}`,
  })),
};

export default function BlogPage() {
  return (
    <div className="min-h-[100dvh] flex flex-col">
      <JsonLd data={blogJsonLd} />
      <Navbar />
      <main className="flex-1 pt-20">
        {/* Hero */}
        <section className="relative min-h-[35dvh] flex items-center overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img
              src="https://readdy.ai/api/search-image?query=Blog%20writing%20workspace%20with%20open%20notebook%20laptop%20and%20fashion%20items%20scattered%20on%20minimal%20wooden%20desk%20warm%20natural%20morning%20light%20creative%20editorial%20photography%20clean%20cozy%20aesthetic%20high%20detail&width=1920&height=600&seq=blog-list-hero&orientation=landscape"
              alt="Blog Kakobuy Spreadsheet"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80" />
          </div>
          <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-16 text-center">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-3">
              Blog Kakobuy Spreadsheet
            </h1>
            <p className="text-sm md:text-base text-background-200/90 max-w-xl mx-auto">
              Artykuły, poradniki i przewodniki o zakupach na Kakobuy. Wszystko czego potrzebujesz aby kupować mądrzej i bezpieczniej.
            </p>
          </div>
        </section>

        {/* Categories filter pills */}
        <section className="w-full px-4 md:px-8 lg:px-12 py-8 bg-background-50 border-b border-background-200">
          <div className="max-w-6xl mx-auto flex flex-wrap items-center gap-2">
            {categories.map((cat) => (
              <button
                key={cat}
                className="px-4 py-2 text-xs md:text-sm rounded-full border border-background-300 text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {cat}
              </button>
            ))}
          </div>
        </section>

        {/* Articles Grid */}
        <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-16 bg-background-50">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {blogArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/blog/${article.slug}`}
                  className="group block bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/40 hover:shadow-md transition-all"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-500">{article.readTime}</span>
                    </div>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>

            <div className="text-center mt-10">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-primary-600 bg-primary-50 px-5 py-2.5 rounded-full hover:bg-primary-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-arrow-left-line" />
                Wróć na stronę główną
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}